import { ShareConfig } from './config';
import shareHeader from '../heybox-share-header'
import openAppPlugin from '../heybox-open-app'

export default {
  install(Vue, options = {}) {
    const shareConfigInstance = Vue.prototype.$hbShareConfig = new ShareConfig(options)
    
    // INFO open-app 自动注册
    Vue.use(openAppPlugin, shareConfigInstance.getConfig('open-app'))

    Object.keys(options).forEach((key) => {
      switch(key) {
        case 'share-header':
          Vue.use(shareHeader, shareConfigInstance.getConfig('share-header'))
          break
        default:
          break
      }
    })
  }
};